export default "__VITE_ASSET__hMFKVyPO__ 100w";